export const fileResourceUrl = 'files';
